export const UPLOADMSG = {
  error_size: 'File exceeds 500KB. Please replace file',
  error_virus: 'Failed virus check. Please upload a different file',
  success_upload: 'Pending Review. Submitted on',
  approved: 'Accepted on',
  rejected: 'File was rejected on',
  error: 'Can NOT upload the file, please try again later'
};

export const MEDIASTATUS = Object.freeze({
  SCANNING: 'scanning',
  APPROVED: 'approved',
  REJECTED: 'rejected',
  REVIEW:   'review',
  EMPTY:    '',
  ERROR:    'error',
  SUCCESS:  'success'
});

//export const LOGO_MAX_SIZE = Number.MAX_SAFE_INTEGER;
export const LOGO_MAX_SIZE =2000000;
export const LOGO_SUPPORT_TYPES=['.svg'];
export const BANNER_MAX_SIZE=500000;
export const BANNER_SUPPORT_TYPES=['.jpg','.jpeg'];

//Markdown used incase description is added to question (via CMS)
export const fileDescriptionLogo = `**Accepted file type:** SVG<br />
**Dimensions:** 1:1 ratio or at least 88 x 88 pixels

**Recommendations:**  

 - Use your official brand colors  
 - Ensure the file is legible   
 - Color contrast should be sufficient to pass accessibility requirements`;
export const fileDescriptionBanner =`**Accepted file type:** JPEG<br />
**Maximum size:** 500KB<br />
**Dimensions:** 1080x288 pixels

**Recommendations:**
- Use a high-definition image
- Crop to size
- Set the focal point of your image in the center-vertical and horizontal
- Avoid faces that may get cut off
- Avoid text-heavy or complex images that may create accessibility challenges`;
